import { RESET_PASSWORD } from "./actionTypes"

export const userResetPassword = (user, history) => {
  return {
    type: RESET_PASSWORD,
    payload: { user, history },
  }
}

export const resetErrorMessage = () => ({
  type: "RESET_ERROR_MESSAGE",
})

export const resetDonwMessage = () => ({
  type: "RESET_DONW_MESSAGE",
})

export const resetUPMessage = () => ({
  type: "RESET_UP_MESSAGE",
})
